/* ZOALIN_COLLECTION_LINK_ROUTER_LIGHT_20260728H_FORCE_2318
   Keep this file small: cached pages load it near the footer, so it should only
   normalize collection links and avoid layout writes or full-page observers. */
(function () {
  var routes = {
    '/collections/all': '/collections/products?sort_by=manual&view=menu-clean-20260728h',
    '/collections/products': '/collections/products?sort_by=manual&view=menu-clean-20260728h',
    '/collections/new-arrivals': '/collections/new-arrivals?sort_by=manual&view=menu-clean-20260728h',
    '/collections/dresses': '/collections/dresses?sort_by=manual&view=menu-clean-20260728h',
    '/collections/sets': '/collections/sets?sort_by=manual&view=menu-clean-20260728h',
    '/collections/abayas': '/collections/abayas?sort_by=manual&view=menu-clean-20260728h'
  };

  function normalizePath(pathname) {
    return pathname && pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
  }

  function targetFor(value) {
    try {
      var url = new URL(value, window.location.origin);
      var target = routes[normalizePath(url.pathname)];
      var view = url.searchParams.get('view');
      var legacyView = view === 'default' || view === 'pc' || /^menu-clean-20260728[a-g]?$/.test(view || '');
      var legacyQuery = !view && url.searchParams.get('sort_by') === 'manual' && url.searchParams.get('page') === '1';

      if (!target || url.origin !== window.location.origin) return '';
      if (url.search && !legacyView && !legacyQuery) return '';
      if (normalizePath(url.pathname) + url.search === target) return '';

      return target + url.hash;
    } catch (error) {
      return '';
    }
  }

  function redirectCurrentPage() {
    var target = targetFor(window.location.href);
    if (target) window.location.replace(target);
  }

  function rewriteKnownLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a[href*="/collections/"]').forEach(function (link) {
      var target = targetFor(link.getAttribute('href'));
      if (target) link.setAttribute('href', target);
    });
  }

  redirectCurrentPage();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { rewriteKnownLinks(document); }, { once: true });
  } else {
    rewriteKnownLinks(document);
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest('a[href*="/collections/"]');
    if (!link) return;

    var target = targetFor(link.getAttribute('href'));
    if (!target) return;

    link.setAttribute('href', target);
    event.preventDefault();
    event.stopPropagation();
    window.location.href = target;
  }, true);
})();
